/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsAjaxCart = {
  cartRenderRequestID: 0,
  preservedMiniCartDiscounts: {},
  init: function ($section) {

    // Add settings from schema to current object
    Shopify.theme.jsAjaxCart = $.extend(this, Shopify.theme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {

      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

      $(document).off('click.ajaxCartTrigger', '[data-ajax-cart-trigger]').on('click.ajaxCartTrigger', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        Shopify.theme.jsAjaxCart.showDrawer();

        return false;
      });

    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnClick();
    }

    this.bindMiniCartQuantity();

    $(document).off('click.ajaxSubmit', '.ajax-submit').on('click.ajaxSubmit', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      Shopify.theme.jsAjaxCart.addToCart($addToCartForm);

      return false;
    });

    $(document).off('click.ajaxCartDelete', '[data-ajax-cart-delete]').on('click.ajaxCartDelete', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).parents('[data-line-item]').data('line-item');
      Shopify.theme.jsAjaxCart.removeFromCart(lineID);

      if (Shopify.theme.jsCart) {
        Shopify.theme.jsCart.removeFromCart(lineID);
      }

      return false;
    });

    $(document).off('click.ajaxCartClose', '[data-ajax-cart-close]').on('click.ajaxCartClose', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      Shopify.theme.jsAjaxCart.hideDrawer();
      Shopify.theme.jsAjaxCart.hideMiniCart();

      return false;
    });

  },
  bindMiniCartQuantity: function () {
    if (window.__caveMiniCartQuantityBound) return;
    window.__caveMiniCartQuantityBound = true;

    document.addEventListener('click', function (e) {
      const button = e.target.closest && e.target.closest('[data-mini-cart-qty]');
      if (!button) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const $button = $(button);
      const $lineItem = $button.parents('[data-line-item]').first();
      const $quantity = $lineItem.find('[data-qty]').first();
      const lineID = $lineItem.data('line-item');
      const currentQuantity = parseInt($quantity.text(), 10) || 1;
      const nextQuantity = $button.data('mini-cart-qty') === 'plus' ? currentQuantity + 1 : currentQuantity - 1;

      if (!lineID || nextQuantity < 1 || $lineItem.hasClass('is-updating')) return false;

      Shopify.theme.jsAjaxCart.updateLineQuantity(lineID, nextQuantity, $lineItem);
      return false;
    }, true);
  },
  showMiniCartOnClick: function () {
    const $el = $('[data-ajax-cart-trigger]');

    $el.off('mouseenter mouseleave');
    $(document).off('click.ajaxMiniCartToggle', '[data-ajax-cart-trigger]').on('click.ajaxMiniCartToggle', '[data-ajax-cart-trigger]', function (e) {
      if (e.target.closest('[data-ajax-cart-mini_cart], [data-ajax-cart-content], #theme-ajax-cart')) {
        return;
      }
      e.preventDefault();

      const $trigger = $(this);
      $('[data-ajax-cart-trigger]').not($trigger).removeClass('show-mini-cart');
      $trigger.toggleClass('show-mini-cart');

      return false;
    });
  },
  hideMiniCart: function () {
    if (this.cart_action != 'mini_cart') return false;
    const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function() {
    const $el = $('.mobile-header [data-ajax-cart-trigger]');

    // Removes url to the cart page so user is not redirected
    $el.attr('href', '#');
  },
  showDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
  },
  hideDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
  },
  removeFromCart: function (lineID, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {
        Shopify.theme.jsAjaxCart.updateView();
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;

      }
    });
  },
  updateLineQuantity: function (lineID, quantity, $lineItem) {
    const $quantity = $lineItem.find('[data-qty]').first();
    const previousQuantity = parseInt($quantity.text(), 10) || 1;
    const lineKey = $lineItem.data('cart-item');
    const existingDiscount = $lineItem.find('.ajax-cart__line-items-discount').first().html();

    if (lineKey && existingDiscount && $.trim(existingDiscount).length && quantity >= 6) {
      Shopify.theme.jsAjaxCart.preservedMiniCartDiscounts[lineKey] = {
        html: existingDiscount,
        expires: Date.now() + 4000
      };
    } else if (lineKey) {
      delete Shopify.theme.jsAjaxCart.preservedMiniCartDiscounts[lineKey];
    }

    $lineItem.addClass('is-updating');
    $lineItem.find('[data-mini-cart-qty]').attr('disabled', 'disabled');
    $quantity.text(quantity);

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + lineID,
      dataType: 'json',
      success: function () {
        Shopify.theme.jsAjaxCart.updateView();
      },
      error: function () {
        $quantity.text(previousQuantity);
        Shopify.theme.jsAjaxCart.updateView(true);
      },
      complete: function () {
        $lineItem.removeClass('is-updating');
        $lineItem.find('[data-mini-cart-qty]').removeAttr('disabled');
        if ((parseInt($quantity.text(), 10) || 1) <= 1) {
          $lineItem.find('[data-mini-cart-qty="minus"]').attr('disabled', 'disabled');
        }
      }
    });
  },
  initializeAjaxCart: function () {
    const requestID = ++Shopify.theme.jsAjaxCart.cartRenderRequestID;

    Shopify.theme.jsAjaxCart.loadCartView(requestID, true);
  },
  initializeAjaxCartOnMobile: function () {

    this.toggleMiniCart();
    const requestID = ++Shopify.theme.jsAjaxCart.cartRenderRequestID;

    Shopify.theme.jsAjaxCart.loadCartView(requestID, true);
  },
  addToCart: function ($addToCartForm) {
    const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');

    function resetAddToCartButton() {
      $addToCartBtn
        .removeAttr('disabled')
        .removeClass('disabled');

      $addToCartBtn.find('.icon')
        .removeClass('zoomOut')
        .addClass('zoomIn');

      $addToCartBtn
        .find('span:not(.icon)')
        .text($addToCartBtn.data('label'))
        .removeClass('zoomOut')
        .addClass('zoomIn');
    }

    function syncSelectedVariant() {
      const $variantSelection = $addToCartForm.closest('[data-product-form]').find('variant-selection[variant]').first();
      const selectedVariant = $variantSelection.attr('variant');
      const $variantField = $addToCartForm.find('[name="id"]').first();

      if (/^\d+$/.test(selectedVariant || '') && $variantField.length) {
        $variantField
          .prop('disabled', false)
          .val(selectedVariant);
        $addToCartBtn.removeAttr('data-options-unselected');
      }
    }

    function getCartError(XMLHttpRequest) {
      if (XMLHttpRequest && XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
        return XMLHttpRequest.responseJSON.description;
      }

      try {
        const parsed = JSON.parse(XMLHttpRequest.responseText || '{}');
        if (parsed && parsed.description) return parsed.description;
      } catch (e) {}

      return 'Sorry, this item could not be added to the cart. Please try again.';
    }

    $addToCartForm.removeClass('shopify-product-form--unselected-error');
    syncSelectedVariant();

    if ($addToCartForm.data('ajaxAdding')) {
      return false;
    }

    if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
      const cartWarning = `<p class="cart-warning__message animated bounceIn">${Shopify.translation.select_variant}</p>`;

      $('.warning').remove();

      $addToCartForm
        .addClass('shopify-product-form--unselected-error')
        .find('.cart-warning')
        .html(cartWarning);

      resetAddToCartButton();
    } else {
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function () {
          $addToCartForm.data('ajaxAdding', true);
          $addToCartBtn
            .attr('disabled', 'disabled')
            .addClass('disabled');

          $addToCartBtn.find('span')
            .removeClass("fadeInDown")
            .addClass('animated zoomOut');
        },
        success: function (product) {

          let $el = $('[data-ajax-cart-trigger]');

          $addToCartBtn
            .find('.checkmark')
            .addClass('checkmark-active');

          if (!isScreenSizeLarge()) {
            $el = $('.mobile-header [data-ajax-cart-trigger]');
            Shopify.theme.scrollToTop($el);
          } else {
            $el = $('[data-ajax-cart-trigger]');
          }

          $el.addClass('show-mini-cart');

          window.setTimeout(function () {
            resetAddToCartButton();
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('.text, .icon').removeClass('fadeInDown');
          }, 350);

          Shopify.theme.jsAjaxCart.showDrawer();
          Shopify.theme.jsAjaxCart.updateView();

          if (Shopify.theme.jsCart) {
            $.ajax({
              cache: false,
              dataType: 'html',
              url: "/cart",
              success: function (html) {
                const cartForm = $(html).find('.cart__form');
                $('.cart__form').replaceWith(cartForm);

              }
            });
          }

        },
        error: function (XMLHttpRequest) {
          const response = getCartError(XMLHttpRequest);

          const cartWarning = `<p class="cart-warning__message animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;

          $('.warning').remove();

          $addToCartForm
            .find('.cart-warning')
            .html(cartWarning);

          resetAddToCartButton();
        },
        complete: function (_XMLHttpRequest, textStatus) {
          $addToCartForm.removeData('ajaxAdding');
          if (textStatus !== 'success') {
            resetAddToCartButton();
          }
        }
      });
    }
  },
  updateCartState: function (itemCount) {
    const hasItems = itemCount > 0;

    $('.ajax-cart__empty-cart-message').toggleClass('is-hidden', hasItems);
    $('.ajax-cart__form').toggleClass('is-hidden', !hasItems);
    $('[data-ajax-cart-trigger]').toggleClass('has-cart-count', hasItems);
    $('[data-bind="itemCount"], [data-cart-count]').text(String(itemCount || 0));
  },
  freshCartUrl: function () {
    const separator = Shopify.routes.cart_url.indexOf('?') === -1 ? '?' : '&';
    return Shopify.routes.cart_url + separator + 'view=ajax&_ajax_cart=' + Date.now();
  },
  loadCartView: function (requestID, skipDiscountRefresh) {
    $.ajax({
      url: Shopify.theme.jsAjaxCart.freshCartUrl(),
      cache: false,
      dataType: 'html',
      headers: {
        'cache-control': 'no-cache'
      },
      success: function (response) {
        const $response = $('<div>').html(response);
        const optionsText = $response.find('[data-options]').first().html();
        const content = $response.find('[data-html="content"]').first().html();
        const options = JSON.parse(optionsText || '{"item_count":0}');

        Shopify.theme.jsAjaxCart.renderCartContent({ content: content || '' }, options, requestID, skipDiscountRefresh);
      }
    });
  },
  keepDiscountTextVisible: function ($content) {
    const preservedDiscounts = Shopify.theme.jsAjaxCart.preservedMiniCartDiscounts || {};

    $content.find('[data-cart-item]').each(function () {
      const $lineItem = $(this);
      const lineKey = $lineItem.data('cart-item');
      const preservedDiscount = preservedDiscounts[lineKey];

      if (!preservedDiscount) return;

      if (Date.now() > preservedDiscount.expires) {
        delete preservedDiscounts[lineKey];
        return;
      }

      const $discount = $lineItem.find('.ajax-cart__line-items-discount').first();
      const hasFreshDiscount = $.trim($discount.html() || '').length > 0;

      if (!hasFreshDiscount) {
        $discount.html(preservedDiscount.html);
      }
    });
  },
  renderCartContent: function (html, options, requestID, skipDiscountRefresh) {
    if (requestID !== Shopify.theme.jsAjaxCart.cartRenderRequestID) return;

    const $content = $('<div>').html(html.content);
    Shopify.theme.jsAjaxCart.keepDiscountTextVisible($content);

    $('[data-ajax-cart-content]').html($content.html());
    Shopify.theme.jsAjaxCart.updateCartState(options.item_count);

    if (Shopify.theme.currencyConverter) {
      Shopify.theme.currencyConverter.convertCurrencies();
    }

  },
  updateView: function (skipDiscountRefresh) {
    const requestID = ++Shopify.theme.jsAjaxCart.cartRenderRequestID;

    Shopify.theme.jsAjaxCart.loadCartView(requestID, skipDiscountRefresh);
  },
  unload: function ($section) {

    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  }
}

/******/ })()
;
